import moment from 'moment';

import gridHeight from '../core/shared-service/grid-utils';
import templateUrl from './division.html';

export const division = {
    templateUrl,
    bindings: {
        invitedEntity: '<', // Les données d'une entité.,
        opened: '<', // indique si le panel est ouvert ou fermer pas defaut
    },
    controllerAs: 'ctrl',
    controller: class Division {
        /*@ngInject*/
        constructor($scope, $state, $translate, KissSellerSvc) {
            this.$scope = $scope;
            this.$state = $state;
            this.$translate = $translate;
            this.KissSellerSvc = KissSellerSvc;
            this.gridApi = null;
        }

        $onInit() {
            var defaultCellTemplate =
                '<a class="grid-cell-link" ui-sref="app.principal.consult.details_divisions({subEntityId : row.entity.id})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
            var relationsTemplate =
                '<div ng-show="row.entity.relations > 0" class="ui-grid-cursor-pointer text-center" ' +
                'ui-sref="app.principal.invbuy-subentity-relations({subEntityId : row.entity.id})"><i class="fa fa-search"></i></div>';

            this.subEntitiesGridOptions = {
                columnDefs: [
                    {
                        name: 'name',
                        displayName: 'kiss_seller.edit.sub_entity.name',
                        headerCellFilter: 'translate',
                        minWidth: '180',
                        cellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default',
                        sort: { direction: 'asc', priority: 0 },
                    },
                    {
                        name: 'code',
                        displayName: 'kiss_seller.edit.sub_entity.code',
                        headerCellFilter: 'translate',
                        width: '120',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default',
                    },
                    {
                        name: 'getAddress()',
                        displayName: 'kiss_seller.edit.sub_entity.address',
                        headerCellFilter: 'translate',
                        minWidth: '180',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default',
                    },
                    {
                        name: 'getCountryLabel()',
                        displayName: 'kiss_seller.edit.sub_entity.country',
                        headerCellFilter: 'translate',
                        width: '100',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default text-center',
                    },
                    {
                        name: 'getStatusLabel()',
                        displayName: 'kiss_seller.edit.sub_entity.status',
                        headerCellFilter: 'translate',
                        width: '80',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default text-center',
                    },
                    {
                        name: 'relations',
                        displayName: 'kiss_seller.edit.sub_entity.relations',
                        headerCellFilter: 'translate',
                        cellTemplate: relationsTemplate,
                        cellClass: 'pointer',
                        width: '80',
                    },
                ],
                exporterOlderExcelCompatibility: false,
                useExternalPagination: false,
                useExternalSorting: false,
                onRegisterApi: gridApi => this.onRegisterApi(gridApi),
                enableSorting: true,
                enableGridMenu: false,
                enableRowSelection: false,
                enableColumnMenus: false,
                paginationPageSizes: [5, 10, 20],
                paginationPageSize: 5,
                data: {},
            };

            this.search();
        }

        onRegisterApi(gridApi) {
            this.gridApi = gridApi;
        }

        getGridHeight() {
            return gridHeight(this.gridApi, this.subEntitiesGridOptions.rowHeight);
        }

        /**
         * Export csv
         */
        exportCsv() {
            this.subEntitiesGridOptions.exporterCsvFilename = `divisions-entite-legale_${
                this.invitedEntity.legalEntity.id
            }_${moment().format('DDMMYYYY')}.csv`;
            this.subEntitiesGridOptions.exporterHeaderFilter = this.$translate.instant;
            this.gridApi.exporter.csvExport('all', 'all');
        }

        /**
         * Recherche des divisions.
         */
        search() {
            if(this.invitedEntity.legalEntity.id) {
                this.subEntitiesGridOptions.data = this.KissSellerSvc.getDivisions(this.invitedEntity.legalEntity.id).then(
                    entities => {
                        this.subEntitiesGridOptions.data = entities;
                    }
                );
            } else {
                this.subEntitiesGridOptions.data = null;
            }
        }
    },
};
